import { startOfMonth, startOfDay, addMonths, differenceInDays } from "date-fns";

export const daysUntilNextMonth = () => {
  const today = startOfDay(new Date());
  const nextMonthStart = startOfMonth(addMonths(today, 1));
  return differenceInDays(nextMonthStart, today);
};
